import React, { useState, useEffect } from 'react';

import Quiz from '../../../pages/activities/Quiz'
import ActivityButton from './ActivityButton';
import Assignment from '@mui/icons-material/Assignment';
import Congratulations from '../Congratulations';
import { useCode } from '../../../contexts/Code';

import { useCheckActivityCompleted } from '../../../hooks/activity'

const ActivityQuiz = ({ session, activity, metadata }) => {
    const isCompleted = useCheckActivityCompleted(activity);

    const {code} = useCode()

    const [quiz, setQuiz] = useState(false);
    const [openQuiz, setOpenQuiz] = useState(false);
    const [congratulations, setCongratulations] = useState(false);

    useEffect(()=> {
        setQuiz(isCompleted);
    }, [isCompleted])

    const congratulationsMessage = code == 45
        ? `Congratulations, you have accumulated ${activity ? activity.score : 100} points!`
        : `¡Felicidades, has acumulado ${activity ? activity.score : 100} puntos!`;

    const buttonTitle = code == 45 ? "Answer Quiz" : "Responder cuestionario";
    if (!code) return null;
    return (
        <>
            <Quiz activity={activity} openQuiz={openQuiz} setOpenQuiz={setOpenQuiz} setQuiz={setQuiz} setCongratulations={setCongratulations} />
            <Congratulations fire={congratulations} message={congratulationsMessage} />

            <ActivityButton
                title={buttonTitle}
                subtitle={`+${activity ? activity.score : 100} puntos`}
                icon={<Assignment />}
                iconColor="success"
                clickWrapper={(e) => {
                    setOpenQuiz(true)
                    localStorage.setItem(code+session.id+'qz', 'true')
                }}
                check={quiz}
                image={"https://i.imgur.com/AuWpPbi.png"}
            />
        </>
    );
};

export default ActivityQuiz;
